import { useTranslation } from 'react-i18next';

import { Icons, IconType } from '../../../constants/icons';
import { SVGIconType } from '../../../constants/svgIcon';
import { JoyajoyImage, SvgIcon } from '../../Molecules';
import { ActionSheetContainer } from '../Containers/ActionSheetContainer';
import styles from './SelectPeriodPopup.module.css';

type SelectPeriodPopupProps = {
  onPrimary: () => void;
  onPeriod: (selected: string, range: string) => void;
  PeriodList: PeriodList;
};

export type PeriodList = [
  {
    name: 'Overall';
    range: string;
    selected: boolean;
  },
  {
    name: 'Today';
    range: string;
    selected: boolean;
  },
  {
    name: 'This Week';
    range: string;
    selected: boolean;
  },
  {
    name: 'Last Week';
    range: string;
    selected: boolean;
  },
  {
    name: 'This Month';
    range: string;
    selected: boolean;
  },
  {
    name: 'Last Month';
    range: string;
    selected: boolean;
  },
];

export const SelectPeriodPopup = (props: SelectPeriodPopupProps) => {
  const { t } = useTranslation();

  // stylings copied from phoneNumberCodePopup
  return (
    <ActionSheetContainer onPrimaryButtonClick={props.onPrimary}>
      <div className={styles.phoneNumber}>
        <div className={styles.titleRow}>
          <SvgIcon
            name={SVGIconType.Period}
            className={styles.periodIcon}
            stroke={'#333'}
            fill={'#333'}
            width={'24px'}
            height={'24px'}
          />
          <p className={styles.title}>{t('Period')}</p>
        </div>
        <p className={styles.minorText}>
          {t('Performance only covers results in the period you select.')}
        </p>
        <hr className={styles.dividerPage} />

        <div className={styles.codeList}>
          {props.PeriodList.map((item, index) => (
            <div key={item.name}>
              <div
                className={styles.codeItem}
                onClick={() => props.onPeriod(item.name, item.range)}
              >
                <div className={styles.vStack}>
                  <p className={styles.periodName}>{t(item.name)}</p>
                  <p className={styles.periodRange}>{item.range}</p>
                </div>
                <div className={styles.rightIcon}>
                  <JoyajoyImage
                    resource={{
                      uri: Icons[
                        item.selected ? IconType.Tick : IconType.EmptyTick
                      ],
                    }}
                    style={{ width: 28, height: 28 }}
                  />
                </div>
              </div>
              {index < props.PeriodList.length - 1 && (
                <hr className={styles.divider} />
              )}
            </div>
          ))}
        </div>
      </div>
    </ActionSheetContainer>
  );
};
